import { FiCheck, FiPlus } from "react-icons/fi";
import { CardActionMenu } from "@/components/ui/CardActionMenu";
import { GoalRing } from "./GoalRing";

interface GoalRowProps {
  name: string;
  /** "$4,200 de $10,000" */
  amountLine: string;
  /** "Vence 20 mar" */
  detailLine?: string;
  percent: number;
  /** "42%" */
  percentLabel: string;
  completed: boolean;
  /** "Completada" */
  completedLabel: string;
  menuLabel: string;
  editLabel: string;
  deleteLabel: string;
  onEdit: () => void;
  onDelete: () => void | Promise<void>;
  onContribute?: () => void;
  contributeLabel?: string;
}

/** Fila compacta de meta: anillo de 56px sobre superficie. El estado completado se dice en texto, no solo en color. */
export const GoalRow = ({
  name,
  amountLine,
  detailLine,
  percent,
  percentLabel,
  completed,
  completedLabel,
  menuLabel,
  editLabel,
  deleteLabel,
  onEdit,
  onDelete,
  onContribute,
  contributeLabel,
}: GoalRowProps) => {
  return (
    <article className="flex items-center gap-4 rounded-[var(--ds-radius-lg)] bg-[var(--ds-surface-raised)] p-4 text-[var(--ds-ink)]">
      <GoalRing
        percent={percent}
        size={56}
        stroke={8}
        color={completed ? "var(--ds-card-lime)" : "var(--ds-card-lilac)"}
        track="var(--ds-line)"
        label={`${name}: ${percentLabel}`}
      />

      <div className="min-w-0 flex-1">
        <h3 className="m-0 break-words text-base font-medium leading-6">{name}</h3>
        <p className="m-0 text-sm leading-5 text-[var(--ds-ink-muted)]">{amountLine}</p>
        {completed ? (
          <p className="m-0 inline-flex items-center gap-1 text-sm font-medium leading-5 text-[var(--ds-positive)]">
            <FiCheck aria-hidden="true" className="h-4 w-4" />
            {completedLabel}
          </p>
        ) : (
          detailLine && <p className="m-0 text-sm leading-5 text-[var(--ds-ink-muted)]">{detailLine}</p>
        )}
      </div>

      {onContribute && contributeLabel && (
        <button
          type="button"
          onClick={onContribute}
          className="app-focus-ring inline-flex min-h-11 shrink-0 items-center gap-2 rounded-full border-[1.5px] border-[var(--ds-ink)] bg-transparent px-4 text-sm font-medium text-[var(--ds-ink)]"
        >
          <FiPlus aria-hidden="true" className="h-4 w-4" />
          {contributeLabel}
        </button>
      )}

      <span className="shrink-0 text-[18px] font-medium leading-6 tabular-nums">{percentLabel}</span>

      <CardActionMenu
        name={name}
        menuLabel={menuLabel}
        actions={[
          { kind: "edit", label: editLabel, onClick: onEdit },
          { kind: "delete", label: deleteLabel, onClick: onDelete },
        ]}
      />
    </article>
  );
};
